const ENV_CODE = process.env.VUE_APP_URL_ENV_CODE
const ENV_SUFFIX = ENV_CODE !== 'prod' ? `-${ENV_CODE}` : ''
const APP_SUBDOMAIN = process.env.VUE_APP_SUBDOMAIN
const BRANCH = process.env.VUE_APP_BRANCH

export const MICRO_FRONTENDS = `https://public-storage.farmapremium.es/applications/micro-frontends/${BRANCH}`
export const TRANSLATIONS_ROUTE = `https://public-storage.farmapremium.es/applications/micro-frontends-translations/${BRANCH}/accounts/`
export const OAUTH_BASE_URL = `https://accountsbackend${ENV_SUFFIX}.farmapremium.es`
export const GATEWAY_BASE_URL = `https://gateway${ENV_SUFFIX}.farmapremium.es/`
export const APPS_DASHBOARDS_URL = `https://apps${ENV_SUFFIX}.farmapremium.es/dashboard`
export const CUSTOMER_SETTINGS_URL = `https://clientes${ENV_SUFFIX}.farmapremium.es`
export const ROOT_SITE = `https://${APP_SUBDOMAIN ? `${APP_SUBDOMAIN}.` : ''}farmapremium.es/`
export const FORM_BASE_URL = OAUTH_BASE_URL

export const LOGO_COLOR = 'https://public-storage-cdn-farmapremium.imgix.net/logos/logo_color_fp_es.png'
export const LOGO_WHITE = 'https://public-storage-cdn-farmapremium.imgix.net/logos/logo_white_fp_es.png'

export const FARMACLOUD_BASE_URL = `https://accounts${ENV_SUFFIX}.farmacloud.io`
export const FARMACLOUD_CLIENT_ID = `farmapremium-${ENV_CODE}`
export const CONTACT_BASE_URL = `${ROOT_SITE}contacta`

export const FP_APPLICATIONS = 'https://public-storage.farmapremium.es/applications'
export const SIGNUP_WITH_GOOGLE = true
export const LOGIN_WITH_GOOGLE = true
